import * as classes from './classes';
// Phaser Plugins
import spineWebGLPlugin from 'phaser/plugins/spine/dist/SpineWebGLPlugin.js';
import VirtualJoystickPlugin from 'phaser3-rex-plugins/plugins/virtualjoystick-plugin.js';

export function addPluginsToScene(scene) {
	try
	{
		scene.load.scenePlugin('SpineWebGLPlugin', window.SpinePlugin, 'spine');
		scene.load.plugin('rexvirtualjoystickplugin', VirtualJoystickPlugin, true);
	} catch(err) {
		console.dir(err);
	}
}

export function setDepthOfGroups(scene)
{
	// Set Depths
	//Lower numbers are on the bottom. Larger numbers are on top of them.
	try
	{
		scene.greenSpacesGroup.setDepth(1);
		scene.bouldersGroup.setDepth(2);
		scene.logsGroup.setDepth(3);
		scene.plantsGroup.setDepth(4);
		scene.treesGroup.setDepth(5);
		scene.cellsGroup.setDepth(6);
		scene.broodsGroup.setDepth(7);
		scene.honeysGroup.setDepth(8);
		scene.beeBreadsGroup.setDepth(9);
		scene.workersGroup.setDepth(20);
		scene.queenBeeGlowsGroup.setDepth(10);
		scene.queenBeesGroup.setDepth(30);
		scene.dronesGroup.setDepth(50);
		scene.waspsGroup.setDepth(60);
		scene.yellowJacketsGroup.setDepth(70);
		scene.varroaMitesGroup.setDepth(80);
		scene.workerSelectionSpritesGroup.setDepth(90);
		scene.uiGroup.setDepth(91);
	} catch(err)
	{
		console.dir(err);
	}
}

export function workersOfQueenBee(queenBee)
{
	return queenBee.scene.workers.filter(
		(worker) => { 
			if (worker.username == queenBee.username) return true 
		}
	)
}

// Get closest stuff.

export function closestQueenBee(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.queenBees.length - 1; i >= 0; i--)
	{
		var target = scene.queenBees[i].queenBeeSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far and not itself, it's the closest.
		if (distance < min && target != source && target.active)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestWorker(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.workers.length - 1; i >= 0; i--)
	{
		var target = scene.workers[i].workerSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far and not itself, it's the closest.
		if (distance < min && target != source && target.active)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestWorkerWithMites(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.workers.length - 1; i >= 0; i--)
	{
		var target = scene.workers[i].workerSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far and not itself, it's the closest.
		if (distance < min && target != source && target.active && target.hasMites)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestEnemyWorker(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.workers.length - 1; i >= 0; i--)
	{
		var target = scene.workers[i].workerSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, not the source bee,
		// not my bee, and is alive, then it's the closest.
		if (
			distance < min &&
			target != source &&
			scene.workers[i].username != source.parent.colonyName &&
			scene.workers[i].workerSprite.active == true)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestEnemyQueenBee(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.queenBees.length - 1; i >= 0; i--)
	{
		var target = scene.queenBees[i].queenBeeSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, not the source queen,
		// and not my queen, then it's the closest.
		if (
			distance < min &&
			target != source &&
			scene.queenBees[i].username != source.username &&
			scene.queenBees[i].queenBeeSprite.active == true)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestWasp(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.wasps.length - 1; i >= 0; i--)
	{
		var target = scene.wasps[i].waspSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, not the source queen,
		// and not my queen, then it's the closest.
		if (
			distance < min &&
			target != source &&
			scene.wasps[i].waspSprite.active == true)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestYellowJacket(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.yellowJackets.length - 1; i >= 0; i--)
	{
		var target = scene.yellowJackets[i].yellowJacketSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, not the source queen,
		// and not my queen, then it's the closest.
		if (
			distance < min &&
			target != source &&
			scene.yellowJackets[i].yellowJacketSprite.active == true)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestCell(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.cells.length - 1; i >= 0; i--)
	{
		var target = scene.cells[i].cellSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, it's closest.
		if (distance < min)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestEmptyCell(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.cells.length - 1; i >= 0; i--)
	{
		var target = scene.cells[i].cellSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, it's closest.
		if (distance < min &&
			target.typeOfCell == 'empty')
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestEmptyYellowJacketCell(scene, source)
{
	try {
		var min = Number.MAX_VALUE;
		var closest = null;
		var x = source.x;
		var y = source.y;

		for (var i = scene.cells.length - 1; i >= 0; i--)
		{
			var target = scene.cells[i].cellSprite;

			var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

			// If this is the shortest distance so far, it's closest.
			if (distance < min &&
				target.typeOfCell == 'empty' &&
				target.species == 'yellowJacket')
			{
				closest = target;
				min = distance;
			}
		}

		return closest;
	} catch (e) {
		console.log('There was an error looking for the nearest empty yellowjacket cell:', e);
	}
}

export function closestBroodWithMites(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.broods.length - 1; i >= 0; i--)
	{
		var target = scene.broods[i].broodSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, and has mites, it's the closest.
		if (distance < min && target.active && target.hasMites)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestYellowJacketBrood(scene, source)
{
	try {
		var min = Number.MAX_VALUE;
		var closest = null;
		var x = source.x;
		var y = source.y;

		for (var i = scene.broods.length - 1; i >= 0; i--)
		{
			var target = scene.broods[i].broodSprite;

			var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

			// If this is the shortest distance so far, it's closest.
			if (distance < min &&
				scene.broods[i].broodStage == 'pupaYellowjacket')
			{
				console.log('There was a closest pupaYellowjacket');
				closest = target;
				min = distance;
			}
		}

		return closest;
	} catch (e) {
		console.log('There was an error looking for the nearest empty yellowjacket cell:', e);
	}
}

export function closestVarroaMite(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.varroaMites.length - 1; i >= 0; i--)
	{
		var target = scene.varroaMites[i].varroaMiteSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, it's the closest.
		if (distance < min && target.active)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestHoney(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.honeys.length - 1; i >= 0; i--)
	{
		var target = scene.honeys[i].honeySprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, it's closest.
		if (
			distance < min &&
			target.active == true
			)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function closestLarva(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.broods.length - 1; i >= 0; i--)
	{
		if (scene.broods[i].broodSprite.broodStage == 'larva')
		{
			var target = scene.broods[i].broodSprite;

			var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

			// If this is the shortest distance so far, it's closest.
			if (distance < min)
			{
				closest = target;
				min = distance;
			}
		}
	}

	return closest;
}

export function closestPlant(scene, source)
{
	var min = Number.MAX_VALUE;
	var closest = null;
	var x = source.x;
	var y = source.y;

	for (var i = scene.plants.length - 1; i >= 0; i--)
	{
		var target = scene.plants[i].plantSprite;

		var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

		// If this is the shortest distance so far, it's closest.
		if (distance < min)
		{
			closest = target;
			min = distance;
		}
	}

	return closest;
}

export function scheckDistanceToClosestCellFromQueen()
{
	var closestCell = this.closestCell(this, this.queenBees[0].queenBeeSprite);
	if (closestCell)
	{
		var distanceToClosestCell = Phaser.Math.Distance.Between(
			this.queenBees[0].queenBeeSprite.x,
			this.queenBees[0].queenBeeSprite.y,
			closestCell.x,
			closestCell.y
		);

		if (distanceToClosestCell < 100 &&
			!this.newHiveButton.inCooldown)
		{
			this.newHiveButton.ready = false;
			this.newHiveButton.setTint(0xafd5aa);
		} else if (!this.newHiveButton.inCooldown) {
			this.newHiveButton.ready = true;
			this.newHiveButton.setTint(16777215);
		}
	}
}

export function spawnQueenBeeBot(scene, x, y, botUserName, botColonyName, botSpecies)
{
	try {
		let isBot = true;
		scene.queenBees.push( new classes.QueenBees(
			scene,
			x,
			y,
			botUserName,
			botColonyName,
			botSpecies,
			isBot)
		);
	} catch(e) {
		console.log('There was an error spawning a new queen bee bot: ', e);
	}
}

export function emitPlusOneHoneyEmitter(scene)
{
	let stopEmitter = function(target)
	{
		target.emitting = false;
	}

	let plusOneHoneyParticles = scene.add.particles(0, 0, 'sprites', {
		frame: 'honeyPlusOne.png',
		speed: 100,
		gravity: {x: 0, y: 0},
		scale: {start: 0.1, end: 1},
		lifespan: 2000,
		quantity: 1,
		follow: scene.queenBees[0].queenBeeSprite,
		maxParticles: 1,
		deathCallback: stopEmitter
	});

	plusOneHoneyParticles.setDepth(900);

}

export function showInterstitialAd()
{
	if (admob)
	{
		const interstitial = new admob.InterstitialAd({
		  adUnitId: 'ca-app-pub-1360350622707615/4228922924',
		});
		interstitial.on('dismiss', () => {
		  console.log("Interstitial dismissed.");
		  globalValues.lastAdTime = Date.now();
		})
		return interstitial.load().then( () => interstitial.show() );
	} else {
		console.log('An interstitial ad would have been shown, but Admob was not available.');
	}
}



// WEBPACK FOOTER //
// ./src/modules/utility.js